(function(angular){
	'use strict';

	angular
		.module('marketingModule')
		.controller('DiversificationLandingController', [
			'globalConfig',
			'orderFormFactory',
			'urlFactory',
			DiversificationLandingFunction
		]);

	function DiversificationLandingFunction(globalConfig, orderFormFactory, urlFactory) {
		var campaigns = this;

		campaigns.handleSelect = function(serviceLevel) {
			if(serviceLevel === 'STARTER') {
				orderFormFactory.submitOrderForm(campaigns.starterPortfolioRiaPlanId, serviceLevel).then(function() {
					urlFactory.redirect('/reits/checkout/start');
				});
			} else if(serviceLevel === 'CORE') {
				urlFactory.redirect('/start-investing-sl/core-plans');
			} else if(serviceLevel === 'ADVANCED') {
				urlFactory.redirect('/start-investing-sl/advanced-plans');
			}
		};

		campaigns.$onInit = function() {
			angular.extend(campaigns, globalConfig);
		};
	}
})(window.angular);